import gql from "graphql-tag";

export const DeleteGoal = gql`
  mutation DeleteGoal($id: [String!]!) {
    deleteGoals(ids: $id)
  }
`;
